import { HistoryMessageItem, useIM, MessageUpdatedByOtherEvent, MessageOutgoingEvent, MessageIncomingEvent } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const MAX_NOT_IN_HISTORY_MESSAGES = 500

export const useNotInHistoryMessagesStore = defineStore('notInHistoryMessages', () => {
  const messagesByEventId = ref(new Map<HistoryMessageItem['eventId'], HistoryMessageItem<MessageOutgoingEvent | MessageIncomingEvent>>())

  const getMessageByEventId = (id: number) => {
    return messagesByEventId.value.get(id)
  }

  const addMessage = (id: number, event: HistoryMessageItem<MessageOutgoingEvent | MessageIncomingEvent>) => {
    if (messagesByEventId.value.size >= MAX_NOT_IN_HISTORY_MESSAGES) {
      const oldestEventId = messagesByEventId.value.keys().next().value
      if (oldestEventId !== undefined) {
        messagesByEventId.value.delete(oldestEventId)
      }
    }
    messagesByEventId.value.set(id, event)
  }

  const { onEditMessage } = useIM()
  onEditMessage((event: MessageUpdatedByOtherEvent) => {
    const eventId = event.targetEventId
    const existingEvent = messagesByEventId.value.get(eventId)
    if (existingEvent) {
      messagesByEventId.value.set(eventId, {
        ...existingEvent,
        item: {
          ...existingEvent.item,
          messageText: event.messageText,
          files: event.files!,
          quote: event.quote!,
          era: event.era,
        },
      })
    }
  })

  return {
    getMessageByEventId,
    addMessage,
  }
})
